{
 "heading": {
  "x": 365,
  "y": 589,
  "w": 218,
  "h": 45
 },
 "buttons": [
  {
   "code": "en",
   "box": {
    "x": 92,
    "y": 704,
    "w": 366,
    "h": 102
   },
   "name": {
    "x": 139,
    "y": 742,
    "w": 105,
    "h": 32
   },
   "soon": null,
   "plate": {
    "id": "row.en",
    "x": 86,
    "y": 698,
    "w": 378,
    "h": 114
   }
  },
  {
   "code": "ja",
   "box": {
    "x": 478,
    "y": 704,
    "w": 368,
    "h": 102
   },
   "name": {
    "x": 526,
    "y": 740,
    "w": 92,
    "h": 31
   },
   "soon": {
    "x": 645,
    "y": 754,
    "w": 56,
    "h": 15
   },
   "plate": {
    "id": "row.ja",
    "x": 472,
    "y": 698,
    "w": 380,
    "h": 114
   }
  },
  {
   "code": "es",
   "box": {
    "x": 92,
    "y": 825,
    "w": 366,
    "h": 102
   },
   "name": {
    "x": 140,
    "y": 862,
    "w": 116,
    "h": 33
   },
   "soon": {
    "x": 280,
    "y": 874,
    "w": 55,
    "h": 15
   },
   "plate": {
    "id": "row.es",
    "x": 86,
    "y": 819,
    "w": 378,
    "h": 114
   }
  },
  {
   "code": "ko",
   "box": {
    "x": 478,
    "y": 825,
    "w": 368,
    "h": 102
   },
   "name": {
    "x": 523,
    "y": 861,
    "w": 91,
    "h": 32
   },
   "soon": {
    "x": 645,
    "y": 874,
    "w": 56,
    "h": 15
   },
   "plate": {
    "id": "row.ko",
    "x": 472,
    "y": 819,
    "w": 380,
    "h": 114
   }
  },
  {
   "code": "pt-BR",
   "box": {
    "x": 92,
    "y": 946,
    "w": 366,
    "h": 103
   },
   "name": {
    "x": 134,
    "y": 985,
    "w": 225,
    "h": 29
   },
   "soon": {
    "x": 377,
    "y": 993,
    "w": 55,
    "h": 15
   },
   "plate": {
    "id": "row.pt-BR",
    "x": 86,
    "y": 940,
    "w": 378,
    "h": 115
   }
  },
  {
   "code": "zh",
   "box": {
    "x": 478,
    "y": 946,
    "w": 368,
    "h": 103
   },
   "name": {
    "x": 523,
    "y": 982,
    "w": 63,
    "h": 32
   },
   "soon": {
    "x": 614,
    "y": 995,
    "w": 55,
    "h": 14
   },
   "plate": {
    "id": "row.zh",
    "x": 472,
    "y": 940,
    "w": 380,
    "h": 115
   }
  },
  {
   "code": "de",
   "box": {
    "x": 92,
    "y": 1067,
    "w": 366,
    "h": 103
   },
   "name": {
    "x": 140,
    "y": 1106,
    "w": 116,
    "h": 26
   },
   "soon": {
    "x": 281,
    "y": 1116,
    "w": 54,
    "h": 15
   },
   "plate": {
    "id": "row.de",
    "x": 86,
    "y": 1061,
    "w": 378,
    "h": 115
   }
  },
  {
   "code": "tr",
   "box": {
    "x": 478,
    "y": 1067,
    "w": 368,
    "h": 103
   },
   "name": {
    "x": 521,
    "y": 1106,
    "w": 99,
    "h": 32
   },
   "soon": {
    "x": 646,
    "y": 1116,
    "w": 55,
    "h": 15
   },
   "plate": {
    "id": "row.tr",
    "x": 472,
    "y": 1061,
    "w": 380,
    "h": 115
   }
  },
  {
   "code": "fr",
   "box": {
    "x": 92,
    "y": 1188,
    "w": 366,
    "h": 103
   },
   "name": {
    "x": 140,
    "y": 1227,
    "w": 119,
    "h": 31
   },
   "soon": {
    "x": 283,
    "y": 1236,
    "w": 54,
    "h": 15
   },
   "plate": {
    "id": "row.fr",
    "x": 86,
    "y": 1182,
    "w": 378,
    "h": 115
   }
  },
  {
   "code": "id",
   "box": {
    "x": 478,
    "y": 1188,
    "w": 368,
    "h": 103
   },
   "name": {
    "x": 522,
    "y": 1229,
    "w": 215,
    "h": 22
   },
   "soon": {
    "x": 762,
    "y": 1237,
    "w": 54,
    "h": 14
   },
   "plate": {
    "id": "row.id",
    "x": 472,
    "y": 1182,
    "w": 380,
    "h": 115
   }
  },
  {
   "code": "it",
   "box": {
    "x": 92,
    "y": 1309,
    "w": 366,
    "h": 103
   },
   "name": {
    "x": 140,
    "y": 1347,
    "w": 108,
    "h": 26
   },
   "soon": {
    "x": 272,
    "y": 1358,
    "w": 53,
    "h": 15
   },
   "plate": {
    "id": "row.it",
    "x": 86,
    "y": 1303,
    "w": 378,
    "h": 115
   }
  },
  {
   "code": "pl",
   "box": {
    "x": 478,
    "y": 1309,
    "w": 368,
    "h": 103
   },
   "name": {
    "x": 523,
    "y": 1347,
    "w": 87,
    "h": 26
   },
   "soon": {
    "x": 635,
    "y": 1358,
    "w": 55,
    "h": 15
   },
   "plate": {
    "id": "row.pl",
    "x": 472,
    "y": 1303,
    "w": 380,
    "h": 115
   }
  }
 ],
 "rule": {
  "S": 456,
  "V": 1672,
  "H": 984,
  "M": 116,
  "dy": 50
 },
 "close": {
  "x": 752,
  "y": 568,
  "w": 84,
  "h": 84
 }
}